import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

interface OptionsInterface {
	cssId: {
		anim?: {
			projectDetailsGalleryHeaderCls: string;
			projectDetailsGalleryTextCls: string;
			projectsGalleryLayout1ImgCls: string;
			projectsGalleryLayout2ImgCls: string;
			projectsGalleryLayout3ImgCls: string;
			projectsGalleryLayout4ImgCls: string;
		}
	},

	slug: string
}

class Gallery extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Projects Details Gallery Module');

		gsap.registerPlugin(ScrollTrigger);

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectDetailsGalleryHeaderCls || '', 'projects_gallery', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectDetailsGalleryTextCls || '', 'projects_gallery', { animCls: 'animate__fadeInLeft25P', once: true});

		let countLayout1Images = 0;
		let countLayout2Images = 0;
		let countLayout3Images = 0;
		let countLayout4Images = 0;

		if(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls) {
			countLayout1Images = document.querySelectorAll(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls).length;
		}

		if(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls) {
			countLayout2Images = document.querySelectorAll(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls).length;
		}

		if(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls) {
			countLayout3Images = document.querySelectorAll(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls).length;
		}

		if(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls) {
			countLayout4Images = document.querySelectorAll(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls).length;
		}

		if(countLayout1Images > 0) {
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '1', 'projects_gallery', { animCls: 'animate__rotateInUpLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '2', 'projects_gallery', { animCls: 'animate__fadeInRight', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '3', 'projects_gallery', { animCls: 'animate__zoomIn50P', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '4', 'projects_gallery', { animCls: 'animate__rotateInDownLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '5', 'projects_gallery', { animCls: 'animate__fadeInUp50P', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '6', 'projects_gallery', { animCls: 'animate__bounceInLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '7', 'projects_gallery', { animCls: 'animate__slideInDown', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '8', 'projects_gallery', { animCls: 'animate__fadeInRight', once: true});
		}

		if(countLayout2Images > 0) {
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '1', 'projects_gallery', { animCls: 'animate__rotateInUpLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '2', 'projects_gallery', { animCls: 'animate__fadeInRight', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '3', 'projects_gallery', { animCls: 'animate__zoomIn50P', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '4', 'projects_gallery', { animCls: 'animate__rotateInDownLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '5', 'projects_gallery', { animCls: 'animate__fadeInUp50P', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '6', 'projects_gallery', { animCls: 'animate__bounceInLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '7', 'projects_gallery', { animCls: 'animate__slideInDown', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '8', 'projects_gallery', { animCls: 'animate__fadeInRight', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout2ImgCls + '9', 'projects_gallery', { animCls: 'animate__fadeInLeft', once: true});
		}

		if(countLayout3Images > 0) {
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls + '1', 'projects_gallery', { animCls: 'animate__fadeInUp', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls + '2', 'projects_gallery', { animCls: 'animate__fadeInLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls + '3', 'projects_gallery', { animCls: 'animate__zoomIn', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout3ImgCls + '4', 'projects_gallery', { animCls: 'animate__slideInRight', once: true});
		}

		if(countLayout4Images > 0) {
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls + '1', 'projects_gallery', { animCls: 'animate__fadeInUp', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls + '2', 'projects_gallery', { animCls: 'animate__fadeInLeft', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls + '3', 'projects_gallery', { animCls: 'animate__zoomIn', once: true});
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsGalleryLayout4ImgCls + '4', 'projects_gallery', { animCls: 'animate__slideInRight', once: true});
		}



		window.addEventListener('load', () => {
			ScrollTrigger.refresh();
		});

		// if(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls) {
		// 	gsap.from(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '1', {
		// 		x: 500, // Move 500px to the right on scroll
		// 		rotation: 360, // Spin fully
		// 		duration: 3,
		// 		scrollTrigger: {
		// 			trigger: this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '1', // Element that starts the trigger
		// 			start: "clamp(top 80%)", // Start when top of box hits 80% of viewport
		// 			end: "clamp(top 20%)", // End animation point
		// 			scrub: true, // Smoothly tie progress to scrollbar position
		// 			invalidateOnRefresh: true, // Recalculate values on refresh
		// 		}
		// 	})
		//
		// 	gsap.from(this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '2', {
		// 		y: 200, // Move 500px to the right on scroll
		// 		scale: 0.5, // Spin fully
		// 		duration: 3,
		// 		scrollTrigger: {
		// 			trigger: this.publicVars.cssId.anim?.projectsGalleryLayout1ImgCls + '2', // Element that starts the trigger
		// 			start: "clamp(top 80%)", // Start when top of box hits 80% of viewport
		// 			end: "clamp(top 20%)", // End animation point
		// 			scrub: true, // Smoothly tie progress to scrollbar position
		// 			invalidateOnRefresh: true, // Recalculate values on refresh
		// 		}
		// 	})
		// }


	}

	bind() {
		this.msg('bind');
	}
}

export default Gallery;